const piiValueFindingsPanel = {
  typeLabels: {
    kennitala: "Kennitala",
    email: "Netfang",
    phone: "Sími (+354)",
    ktCue: "Mögulega kennitala (nálægt 'kt.')",
  },
  header: "⚠ Mögulegar persónuupplýsingar fundust í ómerktum reitum ({{count}})",
  allDecisionsMade: "Allar ákvarðanir teknar — {{count}} verður dulnefnt",
  pendingDecision: "{{count}} þarfnast enn ákvörðunar",
  instructions: {
    intro:
      "Fyrir hvert atriði hér fyrir neðan skaltu ákveða hvað á að gerast við merkta textabútinn:",
    hashLabel: "Dulnefna",
    hashDescription:
      "skiptir grunuðu auðkennisgildi út fyrir dulnefni.",
    dismissLabel: "Hafna",
    dismissDescription: "fölsk jákvæð niðurstaða, skilja eftir óbreytt.",
    columnIntro:
      "Eða meðhöndla allan dálkinn í einu með einni af þessum dálkaaðgerðum:",
    pseudonymizeLabel: "Dulnefna allan dálkinn",
    pseudonymizeDescription:
      "hverjum reit í dálkinum er skipt út fyrir eitt dulnefni fyrir allt innihald reitsins.",
    dropLabel: "Fjarlægja þennan dálk",
    dropDescription: "fjarlægir dálkinn alfarið úr innsendingunni.",
  },
  findingCount_one: "{{count}} atriði",
  findingCount_other: "{{count}} atriði",
  columnDroppedNotice:
    "✗ þessi dálkur verður fjarlægður úr innsendingunni — ákvarðanir fyrir einstök gildi hunsaðar",
  columnPseudonymizedNotice:
    "✓ hverjum reit í þessum dálki verður skipt út fyrir eitt dulnefni fyrir allan reitinn — ákvarðanir fyrir einstök gildi hunsaðar",
  restoreColumn: "Endurheimta dálk",
  restoreColumnTitle: "Endurheimta þennan dálk í innsendinguna",
  hashAllMatchedValues: "Dulnefna öll fundin gildi",
  hashAllMatchedValuesTitle:
    "Fyrir hvert atriði í þessum dálki, skipta eingöngu út fundna textabútnum fyrir dulnefni. Annar texti í reitnum helst óbreyttur.",
  dismissAll: "Hafna öllu",
  dismissAllTitle: "Merkja öll atriði í þessum dálki sem falska jákvæða niðurstöðu",
  pseudonymizeColumn: "Dulnefna allan dálkinn",
  pseudonymizeColumnTitle:
    "Skipta út hverjum reit í þessum dálki fyrir dulnefni af öllu innihaldi reitsins (ekki aðeins fundna textabúta). Ákvarðanir fyrir einstök gildi í þessum dálki eru þá hunsaðar.",
  dropColumn: "Fjarlægja þennan dálk",
  dropColumnTitle:
    "Fjarlægja þennan dálk alfarið úr innsendingunni. Gagnaþjónustan mun aldrei fá hann. Fljótlegra en að hætta við, flytja út aftur án dálksins og senda inn á ný.",
  table: {
    row: "Röð",
    type: "Tegund",
    context: "Samhengi",
    action: "Hvað á að gerast við merkta gildið?",
  },
  willBeHashed: "Verður dulnefnt: {{value}}",
  dismissedNotice: "Hafnað — gildi helst óbreytt",
  hashThisValue: "Dulnefna",
  hashThisValueTitle:
    "Skipta eingöngu út þessum textabút fyrir dulnefni (restin af reitnum helst óbreytt)",
  dismiss: "Hafna",
  dismissTitle: "Fölsk jákvæð niðurstaða — skilja reitinn eftir óbreyttan",
  acknowledge:
    "Ég hef farið yfir öll atriði hér fyrir ofan og staðfesti að skráin er örugg til að senda inn eins og hún er stillt.",
  pendingWarning_one:
    "{{count}} atriði þarfnast enn ákvörðunar — veldu „Dulnefna“, „Hafna“, eða dulnefndu dálkinn.",
  pendingWarning_other:
    "{{count}} atriði þarfnast enn ákvörðunar — veldu „Dulnefna“, „Hafna“, eða dulnefndu dálkinn.",
  redactSummary_one: "{{count}} gildi verður dulnefnt áður en innsending fer fram.",
  redactSummary_other:
    "{{count}} gildi verða dulnefnd áður en innsending fer fram.",
};

export default piiValueFindingsPanel;
